export const SEND_FORGOT_USERNAME_EMAIL_URL = '/advisor-service/advisors/forgot-username';

export const SEND_FORGOT_USERNAME_EMAIL = 'forgotUsername/SEND_FORGOT_USERNAME_EMAIL';
export const SEND_FORGOT_USERNAME_EMAIL_SUCCESS = 'forgotUsername/SEND_FORGOT_USERNAME_EMAIL_SUCCESS';
export const SEND_FORGOT_USERNAME_EMAIL_ERROR = 'forgotUsername/SEND_FORGOT_USERNAME_EMAIL_ERROR';
export const RESET_FORGOT_USERNAME_EMAIL = 'forgotUsername/RESET_FORGOT_USERNAME_EMAIL';
